import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import {
    StoreState,
    createCalculadoraSlice,
    createCompanySlice,
    createCostCenterSlice,
    createDataTableSlice,
    createDateSelectorsSlice,
    createDebugSlice,
    createEmployeeSlice,
    createLocationSlice,
    createNoturnoPreviewSlice,
} from './slices'
import { createLocaisSlice } from './slices/locais'

export const useStore = create<StoreState>()(
    persist(
        (...a) => ({
            customer: null,
            ...createCompanySlice(...a),
            ...createEmployeeSlice(...a),
            ...createCostCenterSlice(...a),
            ...createLocationSlice(...a),
            ...createDateSelectorsSlice(...a),
            ...createLocaisSlice(...a),
            ...createDataTableSlice(...a),
            ...createNoturnoPreviewSlice(...a),
            ...createDebugSlice(...a),
            ...createCalculadoraSlice(...a),
        }),
        {
            name: 'store',
            partialize: state => ({
                employeeId: state.employeeId,
                companyId: state.companyId,
                isDebugToolsEnabled: state.isDebugToolsEnabled,
                dataTable: {
                    colunas: state.dataTable.colunas,
                    variaveis: state.dataTable.variaveis,
                },
            }),
            merge: (persisted, current) => {
                const salvo = persisted as Partial<StoreState> | undefined

                return {
                    ...current,
                    ...salvo,
                    dataTable: {
                        ...current.dataTable,
                        ...salvo?.dataTable,
                    },
                }
            },
        },
    ),
)
